<template>
    <div id="selectproject_main">
        <div v-if="projects" @click="toggleBody" id="selectprojet_header" class="fc-white ff-inter fs-small bt bt-normal br-normal bt-hover-light bg-main noselect">
            <span>{{project ? project.project.name : 'no project selected'}}</span>
            <i class="fas fa-caret-down fs-normal"></i>
        </div>
        <loader v-else></loader>
        <div v-on-clickaway="toggleBody" v-if="open" id="selectproject_body" class="shadow-1 br-big bg-white ff-inter">
            <table id="selectproject_body_projects" v-show="projects">
                <thead class="fs-small">
                    <tr>
                        <th class="selectproject_body_projects_id">ID</th>
                        <th class="selectproject_body_projects_selected"></th>
                        <th class="selectproject_body_projects_icon"></th>
                        <th class="selectproject_body_projects_name">NAME</th>
                        <th class="selectproject_body_projects_position"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="prj in projects" :key="prj.id" class="bg-white noselect bt-hover-dark">
                        <td class="selectproject_body_projects_id fs-small">{{ prj.project.id }}</td>
                        <td><i class="selectproject_body_projects_selected fas fa-check fs-small" :class="(prj.project.id === (project ? project.project.id : null)) ? ' fc-main' : ' fc-gray'"></i></td>
                        <td><i class="selectproject_body_projects_icon fas fa-project-diagram fs-small fc-gray-dark"></i></td>
                        <td class="selectproject_body_projects_name fs-small"><span @click="selectProject(prj.project.id)">{{ prj.project.name }}</span></td>
                        <td class="selectproject_body_projects_position fs-small fc-gray-dark">{{ prj.position.name }}</td>
                    </tr>
                </tbody>
            </table>
            <create-new-input-button id="selectproject_new" @confirm="createProject($event)">New Project</create-new-input-button>
        </div>
    </div>
</template>

<script>
  import { mixin as clickaway } from 'vue-clickaway';
  import Loader from '../miscellaneous/loader'
  import CreateNewInputButton from '../miscellaneous/createNewInputButton'
  export default {
    name: 'selectProject',
    components: { CreateNewInputButton, Loader },
    mixins: [ clickaway ],
    data(){
      return{
        open: false
      }
    },
    computed:{
      projects(){
        return this.$store.getters['Projects/get_projects']
      },
      project(){
        return this.$store.getters['Projects/get_project']
      }
    },
    methods:{
      toggleBody(){
        this.open = !this.open
      },
      selectProject(id){
        if(id !== (this.project ? this.project.project.id : null)){
          this.$store.dispatch('Projects/selectProject', id);
          this.$store.commit('Projects/set_project', null);
          (this.$router.currentRoute.name !== 'Dashboard') ? this.$router.push({name: 'Dashboard'}) : null;
        }
        this.toggleBody()
      },
      createProject(data){
        this.$store.dispatch('Projects/api_create', {name: data});
      }
    },
    mounted () {
      this.$store.dispatch('Projects/api_index');
    }
  }
</script>

<style scoped>
    #selectproject_main{
        display: flex;
        height: 100%;
        align-items: center;
        position: relative;
    }
    #selectprojet_header{
        display: flex;
        height: calc(100% - 10px);
        align-items: center;
        padding-left: 10px;
        padding-right: 10px;
    }
    #selectprojet_header>span{
        margin-right: 10px;
    }
    #selectproject_body{
        display: flex;
        position: absolute;
        top: calc(var(--layout-top-height) + 5px);
        left: 5px;
        padding-top: 10px;
        padding-bottom: 10px;
        flex-direction: column;
        z-index: 100;
        max-height: 400px;
        overflow-y: scroll;
    }
    #selectproject_body_title{
        padding-left: 20px;
    }
    #selectproject_body_projects{
        margin-top: 10px;
        border-collapse: collapse;
    }
    #selectproject_body_projects>tbody>tr>td{
        padding-bottom: 2px;
        padding-top: 2px;
        height: 25px;
        border-top: 1px solid var(--color-gray);
    }
    #selectproject_body_projects>thead>tr>th{
        text-align: left;
        padding-bottom: 10px;
    }
    .selectproject_body_projects_id{
        padding-left: 40px;
    }
    .selectproject_body_projects_selected{
        padding-left: 5px;
        padding-right: 5px;
    }
    .selectproject_body_projects_icon{
        padding-left: 60px;
        padding-right: 5px;
    }
    .selectproject_body_projects_name{
        padding-right: 50px;
        padding-left: 5px;
    }
    .selectproject_body_projects_name>span:hover{
        text-decoration: underline;
        color: var(--color-main);
        cursor: pointer;
    }
    .selectproject_body_projects_position{
        padding-right: 40px;
    }
    #selectproject_new{
        height: 35px;
        width: calc(100% - 20px);
        margin-left: 10px;
        margin-top: 10px;
    }
</style>
